import { Form, Select } from "antd";
import type { Rule } from "rc-field-form/lib/interface";
import { useQuery } from "@apollo/client";
import { GET_REGION_OPTIONS } from "../PatientDashboard/onboardingModal.qql";

type RegionInputProps = {
  name: string,
  label: string,
  rules?: Rule[]
};

const RegionInput = ({
  name, label, rules
}:RegionInputProps) => {
  const { data, loading } = useQuery(GET_REGION_OPTIONS, {
    fetchPolicy: "cache-first",
  });

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
    >
      <Select
        showSearch
        options={data
          ? data.provinces.map(
            (province: { name: string, code: string }) => (
              { value: province.code, label: province.name }
            )
          )
          : []}
        loading={loading}
      />
    </Form.Item>
  );
};

export default RegionInput;
